import React from "react";
import './Main.css';
import { Link } from 'react-router-dom'

const Content1 = () => {

    return(
        <div className="content1">
            
            <iframe className="ytvid" src="https://www.youtube.com/embed/oYabTuIxjew"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            <hr className="new1" />

            {/* <h3>Centar za obrazovanje odraslih</h3>
            <p>Ukoliko želite da radite kao: Trgovci, frizeri, konobari, kuvari, vozači motornih vozila, <br />
                ekonomski, trgovački tehničari, tehničari drumskog saobraćaja, kozmetičari, tehničari elektoenergetike, <br />
                ili medicinski tehničari, a koji nemate završenu trogodišnju školu za trgovca, frizera, konoabara, <br />
                kuvara, vozača motornih vozila, električara, odnosno četverogodišnju za ekonomskog, trgovačkog tehničara, <br />
                tehničara drumskog saobraćaja, kozmetičkog tehničara ili tehničari elektoenergetike, nego imate završene <br />
                razne kurseve za to, koji imaju privremeni karakter i sa kojima nemate pravo otvarati samostalne radnje, <br />
                da iskoristite ovu našu ponudu - da dosta brzo i finansijski jeftino završite stepenovanu jednu od  <br />
                navedenih škola, koja se unosi u radnu knjižicu i sa kojom ako je četvrtog stepena možete nastaviti <br />
                dalje školovanje na državnim ili privatnim fakultetima. <br />
            </p> */}

            <div className>
                <div className="row">
                    <div className="card">
                    <h2>Prekvalifikacija</h2>
                <h4>
                    Prekvalifikacija je obrazovanje i osposobljavanje za drugo zanimanje radi zapošljavanja
                    ili nastavka školovanja.
                    Polaznik koji je već završio srednju školu odnosno stekao srednju stručnu spremu,
                    a želi se prekvalifikovati za drugu vrstu školske spreme III ili IV stepena,
                    srednjoškolski program upisuje kao program prekvalifikacije za sticanje novog zvanja.
                </h4>
                <a><Link to="/prekvalifikacija">Saznaj vise</Link></a>
                    </div>
                    <div className="card">
                    <h2>Dokvalifikacija</h2>
                <h4>
                    Dokvalifikacija je sticanje novog znanja u
                    okviru iste struke za zanimanje višeg stepena složenosti s ciljem povećanja kompetencija.
                    Ukoliko je polaznik završio samo osnovnu školu ili je započeo, ali nije završio
                    srednju školu, srednjoškolski program se upisuje i pohađa kao program dokvalifikacije.
                    Polaznik je pri tome napunio 18 godina života.
                </h4>
                <a><Link to="/dokvalifikacija">Saznaj vise</Link></a>
                    </div>
                </div>
                <div className="row">
                    <div className="card">
                    <h2>Osposobljavanje</h2>
                    <h4>Nastavni programi za stručno osposobljavanje su urađeni da osposobe polaznike za samostalan rad na
                        manje složenim poslovima na gradilištima, u skladištima i drugim odgovarajućim mjestima.
                    </h4>
                    <a><Link to="/osposobljavanje">Saznaj vise</Link></a>
                    </div>
                </div>
            </div>


        </div>
    );

}

export default Content1;